import React from "react";
import { Link, useParams } from "react-router-dom";
import Slider from "react-slick";
import Card from "../Card"; // Import your Card component

const ProductShowcaseComponent = ({
  title,
  productList,
  handleAddToCart,
  slug,
}) => {
  // Custom arrow components for the slider
  const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className}  pb-120 slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  };

  // Slick slider settings
  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1599,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 1399,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 1199,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 775,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 624,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="organic-food">
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8 align-items-end">
            <h2 className="mb-0 text-xl">{title}</h2>
            <div className="flex-align mr-point gap-16">
              <Link
                to={`/salespages/${slug || "default-category"}`}
                className="text-sm pt-20 fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
              >
                See More
              </Link>
            </div>
          </div>
        </div>
        <div className="organic-food__slider arrow-style-two">
          <Slider {...settings}>
            {productList.map((product) => {
              const {
                productId,
                image,
                title,
                badge,
                offered,
                purchased,
                freeDelivery,
                selling,
                slug,
                soldOut,
                productViews,
                reviewCount,
                averageRating,
                inventoryMap,
              } = product;
              // Accessing the first item of the defaultInventory array
              const defaultInventoryId =
                inventoryMap?.defaultInventory?.[0]?.id || null;

              return (
                <Card
                  key={productId}
                  imageSrc={image}
                  title={title}
                  badge={badge}
                  offered={selling}
                  purchased={offered}
                  productLink={`/product/${slug}`}
                  cartLink="/cart"
                  soldOut={soldOut}
                  productViews={productViews}
                  reviewCount={reviewCount}
                  averageRating={averageRating}
                  productInventoryId={defaultInventoryId}
                  freeDelivery={freeDelivery}
                />
              );
            })}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcaseComponent;
